import React from 'react';
import propTypes from 'prop-types';
import {get} from 'lodash';
import styled from '@emotion/styled';
import {Controller} from "react-hook-form";
import {format} from 'date-fns';

import Checkbox from '../../../../components/forms/Checkbox';
import Text from '../../../../components/typography';
import Links from '../../../../components/ui/Links';
import {theme} from '../../../../themes/default-theme';


const SummaryItem = styled.div`
  margin: 35px 0;
`

const SummaryItemHeader = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
  border-bottom: 1px solid ${theme.palette.middleGrey};

`

const SummaryItemBody = styled.div`

`

const SummaryItemItem = styled.div`
  margin: 7px 0;
  display: flex;
`

const SummaryItemType = styled.div`
  min-width: 160px;
`

const SummaryItemVal = styled.div`

`


const FormItem = styled.div`
  display: block;
  margin:${props => props.margin === 'none' ? `0` : `15px 0`};
`

const Error = styled.p`
  color: ${theme.palette.error.form}
`

const Step5 = ({formProps, state, summary, country, setStep, showSeries = true}) => {

  const {
    control,
    errors
  } = formProps

  const formatDate = (date) => {
    if (date.length === 0) {
      return ''
    }
    const formattedDate = format(date, 'E, do MMM yyyy');
    return formattedDate.toString();
  }

  const dealerTitle = typeof window !== 'undefined' && process.env.DEALER_SITE ? window.staticly.dealerData.name : "{{data.template.dealer.name}}"


  return (
    <>

      {summary.step1 && summary.step1.length > 0 && summary.step1.map((item, index) => {
        return (
          <SummaryItem key={index}>
            <SummaryItemHeader>
              <Text variant="h6" colour="black">Model {index + 1} details</Text>
              <Links href="#" onClick={() => setStep(1)}>Modify</Links>
            </SummaryItemHeader>
            <SummaryItemBody>
              <SummaryItemItem>
                <SummaryItemType><Text variant="body1" colour="black">Range:</Text></SummaryItemType>
                <SummaryItemVal><Text variant="body1">{item.rangeTitle}</Text></SummaryItemVal>
              </SummaryItemItem>
              <SummaryItemItem>
                <SummaryItemType><Text variant="body1" colour="black">{showSeries ? 'Series' : 'Model'}:</Text></SummaryItemType>
                <SummaryItemVal><Text variant="body1">{item.seriesTitle}</Text></SummaryItemVal>
              </SummaryItemItem>
              {showSeries &&
                <SummaryItemItem>
                  <SummaryItemType><Text variant="body1" colour="black">Model:</Text></SummaryItemType>
                  <SummaryItemVal><Text variant="body1">{item.title}</Text></SummaryItemVal>
                </SummaryItemItem>
              }
            </SummaryItemBody>
          </SummaryItem>
        )
      })}
      
      {summary.dealerSummary &&
        <SummaryItem>
          <SummaryItemHeader>
            <Text variant="h6" colour="black">Dealer details</Text>
            <Links href="#" onClick={() => setStep(2)}>Modify</Links>
          </SummaryItemHeader>
          <SummaryItemBody>
            <SummaryItemItem>
              <SummaryItemType><Text variant="body1" colour="black">Name:</Text></SummaryItemType>
              <SummaryItemVal><Text variant="body1">{get(summary, 'dealerSummary.name', '')}</Text></SummaryItemVal>
            </SummaryItemItem>
            <SummaryItemItem>
              <SummaryItemType><Text variant="body1" colour="black">Address:</Text></SummaryItemType>
              <SummaryItemVal><Text variant="body1">{get(summary, 'dealerSummary.address', '')}</Text></SummaryItemVal>
            </SummaryItemItem>
            <SummaryItemItem>
              <SummaryItemType><Text variant="body1" colour="black">Contact number:</Text></SummaryItemType>
              <SummaryItemVal><Text variant="body1">{get(summary, 'dealerSummary.phone', '')}</Text></SummaryItemVal>
            </SummaryItemItem>
          </SummaryItemBody>
        </SummaryItem>
      }

      <SummaryItem>
        <SummaryItemHeader>
          <Text variant="h6" colour="black">Your details</Text>
          <Links href="#" onClick={() => setStep(3)}>Modify</Links>
        </SummaryItemHeader>
        <SummaryItemBody>
          <SummaryItemItem>
            <SummaryItemType><Text variant="body1" colour="black">First Name:</Text></SummaryItemType>
            <SummaryItemVal><Text variant="body1">{get(summary, 'step3.first_name', '')}</Text></SummaryItemVal>
          </SummaryItemItem>
          <SummaryItemItem>
            <SummaryItemType><Text variant="body1" colour="black">Last Name:</Text></SummaryItemType>
            <SummaryItemVal><Text variant="body1">{get(summary, 'step3.last_name', '')}</Text></SummaryItemVal>
          </SummaryItemItem>
          <SummaryItemItem>
            <SummaryItemType><Text variant="body1" colour="black">Email:</Text></SummaryItemType>
            <SummaryItemVal><Text variant="body1">{get(summary, 'step3.email', '')}</Text></SummaryItemVal>
          </SummaryItemItem>
          <SummaryItemItem>
            <SummaryItemType><Text variant="body1" colour="black">Contact Number:</Text></SummaryItemType>
            <SummaryItemVal><Text variant="body1">{get(summary, 'step3.phone', '')}</Text></SummaryItemVal>
          </SummaryItemItem>
        </SummaryItemBody>
      </SummaryItem>


      {/* <SummaryItem>
        <SummaryItemHeader>
          <Text variant="h6" colour="black">Date &amp; Time</Text>
          <Links href="#" onClick={() => setStep(4)}>Modify</Links>
        </SummaryItemHeader>
        <SummaryItemBody>
          <SummaryItemItem>
            <SummaryItemType><Text variant="body1" colour="black">Date:</Text></SummaryItemType>
            <SummaryItemVal><Text variant="body1">{formatDate(get(summary, 'step4.date', ''))}</Text></SummaryItemVal>
          </SummaryItemItem>
          <SummaryItemItem>
            <SummaryItemType><Text variant="body1" colour="black">Time:</Text></SummaryItemType>
            <SummaryItemVal><Text variant="body1">{get(summary, 'step4.time', '')}</Text></SummaryItemVal>
          </SummaryItemItem>
        </SummaryItemBody>
      </SummaryItem> */}
      <FormItem>
        <Controller
          as={Checkbox}
          name="newsletter"
          type="checkbox"
          control={control}
          label={`Sign me up for ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} e-Newsletter`}
          error={get(errors, `[newsletter]`, false) ? true : false}
          defaultValue={state.newsletter || false}
          rules={{
            type: 'custom'
          }}
        />
      </FormItem>
      <FormItem>
        <Controller
          as={Checkbox}
          name="privacy"
          type="checkbox"
          control={control}
          label={`I have read and agree to ${process.env.DEALER_SITE ? `${dealerTitle}'s` : `Jayco ${country}`} <a href="/privacy" target="_blank">Privacy Policy</a>*`}
          error={get(errors, `[privacy]`, false) ? true : false}
          defaultValue={state.privacy || false}
          rules={{
            required: true,
            type: 'custom'
          }}
        />
        {get(errors, `[privacy]`, false) && <Error>This field is required</Error>}

      </FormItem>
    </>
  )
}

Step5.propTypes = {
  showSeries: propTypes.bool
}

export default Step5